import { IMsalContext } from "@azure/msal-react";
import axios, { AxiosError } from "axios";
import { getAccessToken } from "config/token";
import { NEXUS_API_BASE_URL_V2 } from "const";
import { handleRequestError } from "helpers";

export interface IUserAccess {
  user_email: string;
  access_level: string;
}

export interface IGroupAccess {
  group_name: string;
  access_level: string;
}

export interface IEditMetadataResponse {
  rnd_project_id: string;
  "created-on": string;
  retention_period_value: string;
  "last-modified-by": string;
  requested_for: string;
  "last-update": string;
  space_description: string;
  "primary-data-domain": string;
  classification: string;
  mapped_users: IUserAccess[];
  "created-by": string;
  retention_period_type: string;
  licensing_obligation: string;
  mapped_groups: IGroupAccess[];
  datasource: string;
  rnd_study_id: string;
  "region-name": string;
  name: string;
  secondary_data_domain: string;
  "registration-date": string;
  [key: string]: any;
}

export const fetchEditMetadata = async (
  msalInstance: IMsalContext,
  bucketName: string,
  spaceName: string,
  region: string,
  domainName: string,
): Promise<IEditMetadataResponse | null | string> => {
  try {
    const token = await getAccessToken(msalInstance);
    const bearerToken = `Bearer ${token?.token || ""}`;

    const requestURL = `${NEXUS_API_BASE_URL_V2}/nexus/get-metadata?bucket_name=${bucketName}&space_name=${spaceName}&region=${region}&data_domain_name=${domainName}`;

    const config = {
      headers: {
        Authorization: bearerToken,
      },
    };

    const response = await axios.get(requestURL, config);

    if (response.data) {
      const raw = response.data;

      const parsedUsers =
        typeof raw.mapped_users === "string"
          ? JSON.parse(raw.mapped_users || "[]")
          : raw.mapped_users || [];

      const parsedGroups =
        typeof raw.mapped_groups === "string"
          ? JSON.parse(raw.mapped_groups || "[]")
          : raw.mapped_groups || [];

      return {
        ...raw,
        // Decode URL-encoded fields
        "created-on": decodeURIComponent(raw["created-on"] || ""),
        "registration-date": decodeURIComponent(raw["registration-date"] || ""),
        space_description: decodeURIComponent(raw?.space_description || ""),
        datasource: decodeURIComponent(raw?.datasource || ""),
        // Safely parsed values
        mapped_users: parsedUsers,
        mapped_groups: parsedGroups,
      } as IEditMetadataResponse;
    }

    return null;
  } catch (error) {
    console.error("Error fetching metadata for edit:", error);
    throw new Error(handleRequestError(error as AxiosError | { message: string }).error);
  }
};
